import {useEffect, useState} from "react";
import axios from "axios";

const UpdateRoleModal = ({ role, updateRoleModal, setUpdateRoleModal, setRoles, index}) => {

    const [permissions, setPermissions] = useState([]);
    const [updateRole, setUpdateRole] = useState(role);

    useEffect(() => {
        setUpdateRole(role)

        axios.get('permissions').then(response => {
            setPermissions(response.data.permissions)
        })
    }, [])

    const handleRefresh = () => {
        axios.get('roles').then(response => {
            setRoles(response.data.roles)
        })
    }

    const handleSave = () => {
        axios.put(`roles/${updateRole.id}`, {
            name: updateRole.name,
            permissions: updateRole.permissions.map(pluck("id"))
        }).then(response => {
            handleModalTrigger(index)
            handleRefresh()
        })
    }

    const handleModalTrigger = (index) => {
        setUpdateRoleModal(state => state.map((trigger, triggerIndex) => {
            return !triggerIndex === index
        }))
    }
    const pluck = property => element => element[property]

    const handlePermissionChoice = (event, selectedPermission) => {
        if (event.target.checked){
            setUpdateRole({
                ...updateRole,
                permissions: [...updateRole.permissions, selectedPermission]
            })
        } else {
            setUpdateRole({
                ...updateRole,
                permissions: updateRole.permissions.filter(item => !(item.id === selectedPermission.id))
            })
        }
    }


    return (
        <div className={`modal fade ${updateRoleModal && "show"}`} id="kt_modal_add_role" tabIndex="-1" aria-hidden="true" style={{display: updateRoleModal ? 'block' : 'none'}}>
            <div className="modal-dialog modal-dialog-centered mw-850px">
                <div className="modal-content">
                    <div className="modal-header">
                        <h2 className="fw-bolder">Edit a Role</h2>
                        <div onClick={() => handleModalTrigger(index)} className="btn btn-icon btn-sm btn-active-icon-primary"
                             data-kt-roles-modal-action="close">
                                    <span className="svg-icon svg-icon-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                             viewBox="0 0 24 24" fill="none">
                                            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2"
                                                  rx="1" transform="rotate(-45 6 17.3137)" fill="black"/>
                                            <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                                  transform="rotate(45 7.41422 6)" fill="black"/>
                                        </svg>
                                    </span>
                        </div>
                    </div>
                    <div className="modal-body scroll-y mx-lg-5 my-7">
                        <form id="kt_modal_add_role_form" className="form" action="#">
                            <div className="d-flex flex-column scroll-y me-n7 pe-7"
                                 id="kt_modal_add_role_scroll" data-kt-scroll="true"
                                 data-kt-scroll-activate="{default: false, lg: true}"
                                 data-kt-scroll-max-height="auto"
                                 data-kt-scroll-dependencies="#kt_modal_add_role_header"
                                 data-kt-scroll-wrappers="#kt_modal_add_role_scroll"
                                 data-kt-scroll-offset="300px">
                                <div className="fv-row mb-10">
                                    <label className="fs-5 fw-bolder form-label mb-2">
                                        <span className="required">Role name</span>
                                    </label>
                                    <input className="form-control form-control-solid"
                                           placeholder="Enter a role name" name="role_name"
                                           value={updateRole.name}
                                           onChange={event => setUpdateRole({...updateRole, name: event.target.value})}
                                    />
                                </div>
                                <div className="fv-row">
                                    <label className="fs-5 fw-bolder form-label mb-2">Role Permissions</label>
                                    <div className="table-responsive">
                                        <table className="table align-middle table-row-dashed fs-6 gy-5">
                                            <tbody className="text-gray-600 fw-bold">
                                            {
                                                Object.entries(permissions).map(([groupName, groupPermissions], index) => (
                                                    <tr key={index}>
                                                        <td className="text-gray-800">{groupName}</td>
                                                        <td>
                                                            <div className="d-flex">
                                                                {
                                                                    groupPermissions.map((groupPermission, innerIndex) => (
                                                                        <label key={innerIndex}
                                                                               className="form-check form-check-sm form-check-custom form-check-solid me-5 me-lg-20">
                                                                            <input onChange={event => handlePermissionChoice(event, groupPermission)} className="form-check-input" type="checkbox"
                                                                                   value="" name="user_management_read"
                                                                                   checked={
                                                                                        updateRole.permissions.some(permissions => permissions.id === groupPermission.id)
                                                                                   }
                                                                            />
                                                                            <span className="form-check-label">{groupPermission.name.split(" : ")[1]}</span>
                                                                        </label>
                                                                    ))
                                                                }
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center pt-15">
                                <button onClick={() => handleModalTrigger(index)} type="reset" className="btn btn-light me-3"
                                        data-kt-roles-modal-action="cancel">Discard
                                </button>
                                <button onClick={handleSave} type="button" className="btn btn-primary"
                                        data-kt-roles-modal-action="submit">
                                    <span className="indicator-label">Submit</span>
                                    <span className="indicator-progress">Please wait...
                                                <span
                                                    className="spinner-border spinner-border-sm align-middle ms-2">
                                                </span>
                                            </span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpdateRoleModal;